<div
  *ngrxLet="(thirdPartyModel$ | async | ready)?.properties?.value?.value as deviceThirdpartyModel"
  class="flex flex-row gap-[8px]"
>
  <img
    class="device-img"
    [src]="
      deviceThirdpartyModel ? imagePath.wallbox3rdPartImagePath : imagePath.wallboxDefaultImagePath
    "
  />
  <div class="flex flex-col">
    <span class="tile-title">
      <ng-container *ngIf="deviceThirdpartyModel; else showDefaultTitle">
        {{ deviceThirdpartyModel }}
      </ng-container>
      <ng-template #showDefaultTitle>
        {{ '+INSTALLATIONS.INSTALLATIONS.WALLBOX.WALLBOX_TILE' | translate }}
      </ng-template>
    </span>
    <div class="serial-container">
      <span *ngIf="wallboxEtn$ | async | ready as feature" class="serial">
        <ng-container>
          {{ feature?.properties?.value?.value }}
        </ng-container>
      </span>
    </div>
  </div>
</div>
